import { Component, DestroyRef, inject, OnInit } from "@angular/core";
import {
  IGridScreen,
  IGridWidget,
  IGridWidgetSettings,
} from "@modules/grid/models/grid-manager";
import { GridManagerService } from "@modules/grid/services/grid-manager.service";
import { InterfaceManagementApiService } from "@dmms/shared/data-access/interface-management/services/interface-management-api.service";

@Component({
  selector: "app-grid-dynamic-widget",
  templateUrl: "./grid-dynamic-widget.component.html",
  styleUrl: "./grid-dynamic-widget.component.scss",
  standalone: false,
})
export class GridDynamicWidgetComponent implements OnInit {
  grids: IGridWidget[] = [];
  screens: IGridScreen;
  loading = true;
  destroyRef = inject(DestroyRef);
  gridService = inject(GridManagerService);
  apiService = inject(InterfaceManagementApiService);

  ngOnInit(): void {
    this.loadGrids().then();
  }

  async loadGrids() {
    const gridPage = await this.gridService.getGridScreen();
    this.screens = gridPage?.screen;
    this.grids = (this.screens?.grids || []).map((w) => {
      return {
        ...w,
        ...{ component: this.gridService.getComponent(w.component) },
      };
    });

    this.loading = false;
  }

  getStyles(settings: IGridWidgetSettings) {
    return {
      height: settings?.height,
      width: settings?.width,
      top: settings?.top,
      bottom: settings?.bottom,
      left: settings?.left,
      right: settings?.right,
      "z-index": settings?.zIndex,
      "border-left": settings?.bl,
      "border-right": settings?.br,
      "border-top": settings?.bt,
      "border-bottom": settings?.bb,
      padding: settings?.padding,
      position: settings?.position,
    };
  }
}
